<app-header></app-header>
<section class="bredcrumb">
  <div class="container">
    <ul class="brd-nav">
      <li><a routerLink="/"> Home </a></li>
      <li><span> Ambulance Tracking </span></li>
    </ul>
  </div>
</section>

<div *ngIf="bookingId!=''" class="ambulance-container-btn">
  <button (click)="cancelBooking()" class="btn btn-style ambulance-cancel-btn">Cancel Booking</button>
</div>

<!-- Google Maps Angular Component (replaces AGM) -->
<google-map
  [height]="'600px'"
  [width]="'100%'"
  [zoom]="zoom"
  [center]="{ lat: +lat || 28.6139, lng: +lng || 77.2090 }">
  <map-marker
    *ngFor="let data of searchResultData"
    [position]="{ lat: +data.lat, lng: +data.lng }"
    [title]="data.name || ''">
  </map-marker>
</google-map>

<input type="hidden" id="booking_cancel_popup_trigger" data-toggle="modal" data-target="#booking_cancel_popup">
<div class="modal fade" id="booking_cancel_popup">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-header">
          <h5 class="modal-title">Cancel booking</h5>
        </div>
        <h3>Booking Cancelled...</h3>
        <button (click)="redirectHomePage()" class="btn btn-small btn-style text-center"
          style="margin: 17px auto 0;display: block;">Ok</button>
      </div>
    </div>
  </div>
</div>
